import classNames from 'classnames';
import MLIcon from '../../../../MLIcon/MLIcon';

import s from './TrendChip.module.css';

import {
  ISG_REPORT_VIEW_OPTIONS,
  ISG_TREND_TYPES,
  ISG_TREND_COMPONENT_TYPES,
  ISG_PERFORMANCE_VIEW,
  ISG_TREND_NOT_AVAILABLE,
} from '../../../../../utils/constants';

export const TrendChip = ({ value, type, currentView }) => {
  const formattedCurrentView = currentView?.toLowerCase() || '';
  const numberValue = Number(value);

  // In case we can't calculate the trend, show unavailable message
  if (value === ISG_TREND_NOT_AVAILABLE) {
    return (
      <div
        className={s.trends}
        data-test-id="individual-student-gb-comparison-unavailable"
      >
        <div className={classNames(s.trendsLabel, s.trendsLabelFlat)}>
          Comparison Unavailable
        </div>
      </div>
    );
  }

  if (type === ISG_TREND_COMPONENT_TYPES.SCORE) {
    // Default to no change
    let trend = ISG_TREND_TYPES.FLAT;
    let trendToDisplay = '';
    let icon = 'minus';

    if (value > 0) {
      trend = ISG_TREND_TYPES.UP;
      trendToDisplay = 'Up';
      icon = 'chevron_double_up';
    } else if (value < 0) {
      trend = ISG_TREND_TYPES.DOWN;
      trendToDisplay = 'Down';
      icon = 'chevron_double_down';
    }

    const formattedValue =
      numberValue === 0 ? 'No change' : `${Math.abs(numberValue)}%`;

    const trendClasses = classNames(s.trendsLabel, {
      [s.trendsLabelUp]: trend === ISG_TREND_TYPES.UP,
      [s.trendsLabelDown]: trend === ISG_TREND_TYPES.DOWN,
      [s.trendsLabelFlat]: trend === ISG_TREND_TYPES.FLAT,
    });

    const conditionalFrom =
      currentView !== ISG_PERFORMANCE_VIEW ? 'from last' : 'over the';

    return (
      <div className={s.trends}>
        <div className={trendClasses}>
          <MLIcon className={s.trendIcon} type={icon} height="16" width="16" />
          {`${trendToDisplay} ${formattedValue} ${conditionalFrom} ${formattedCurrentView}`}
        </div>
      </div>
    );
  } else if (type === ISG_TREND_COMPONENT_TYPES.UNCOMPLETED_ACTIVITIES) {
    const trend = numberValue > 0 ? ISG_TREND_TYPES.DOWN : ISG_TREND_TYPES.UP;
    const conditionalIn =
      currentView === ISG_REPORT_VIEW_OPTIONS.WEEK ? '' : 'in';

    const conditionalThis = currentView !== ISG_PERFORMANCE_VIEW ? 'this' : '';

    const trendClasses = classNames(s.trendsLabel, {
      [s.trendsLabelUp]: trend === ISG_TREND_TYPES.UP,
      [s.trendsLabelDown]: trend === ISG_TREND_TYPES.DOWN,
    });

    const plurizedActivities = numberValue === 1 ? 'activity' : 'activities';

    return (
      <div className={s.trends}>
        <div
          className={trendClasses}
        >{`${value} uncompleted ${plurizedActivities} ${conditionalIn} ${conditionalThis} ${formattedCurrentView}`}</div>
      </div>
    );
  }

  return null;
};
